import {Box, IconButton, List, ListItem, ListItemIcon, ListItemText, TextField} from "@mui/material";
import React, {ChangeEventHandler, useState} from "react";
import { Projects, Users as UsersType } from "../../redux/types/firebase";
import { connect } from "react-redux";
import UserDetails from "./UserDetails";
import { selectProjects } from "../../redux/selectors/firebase";
import { DescribeRoles } from "./Roles";
import { Edit } from "@mui/icons-material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    list: {
        flexGrow: 1,
        maxHeight: 500,
        overflowY: "scroll",
        '&::-webkit-scrollbar': {
            width: '0.4em'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            borderRadius: '0.4em'
        }
    },
    flexBox: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    }
}));

interface Props
{
    projects: Projects
    users: UsersType
}

function Users({ projects, users }: Props)
{
    const classes = useStyles();
    const [filter, setFilter] = useState("");
    const [showDetails, setShowDetails] = useState<string | undefined>();
    const handleEditClick = ({ currentTarget }: React.MouseEvent<HTMLElement>) =>
        setShowDetails(currentTarget.dataset.user);
    const handleDetailsClose = () => setShowDetails(undefined);
    const handleFilterChange: ChangeEventHandler<HTMLInputElement> = (({target}) =>
        setFilter(target.value));

    return (
        <Box className={classes.flexBox}>
            {showDetails !== undefined &&
                <UserDetails
                    projects={projects} user={users[showDetails]} userKey={showDetails}
                    onClose={handleDetailsClose} />}
            <Box className={classes.flexBox}>
                <Box m={1}>
                    <TextField fullWidth label="Filter" onChange={handleFilterChange} size="small" value={filter}/>
                </Box>
                <Box className={classes.list}>
                    <List>
                        {Object.keys(users || {}).sort((lhs, rhs) =>
                            (users[lhs].name || lhs).localeCompare(users[rhs].name || rhs)
                        )
                            .filter(key => users[key].name?.toLowerCase().includes(filter) ||
                                users[key].email?.toLowerCase().includes(filter))
                            .map((key, index) => {
                                const user = users[key];
                                const initialised = user.initialised ? new Date(user.initialised).toLocaleDateString() : "";
                                const secondary = `${user.email || ""} ${initialised} ${DescribeRoles(user.roles, projects)}`;

                                return (
                                    <ListItem key={key} style={{ backgroundColor: index & 1 ? "rgba(1,1,1,0.05)" : undefined }}>
                                        <ListItemText primary={user.name || key} secondary={secondary} />
                                        <ListItemIcon>
                                            <IconButton data-user={key} onClick={handleEditClick} size="large">
                                                <Edit />
                                            </IconButton>
                                        </ListItemIcon>
                                    </ListItem>
                                );
                            })}
                    </List>
                </Box>
            </Box>
        </Box>
    );
}
const mapStateToProps = (store: never) => ({
    projects: selectProjects(store)
});

export default connect(mapStateToProps, {
})(Users);
